import * as Yup from "yup";

export const initialValues = {
  resourceName: "",
  resourceDescription: "",
  resourceUrl: "",
};

export const getValidationSchema = () =>
  Yup.object().shape({
    resourceName: Yup.string().required("This field is required"),
    resourceDescription: Yup.string().required("This field is required"),
    resourceUrl: Yup.string().required("This field is required"),
  });
